import React from "react";
import MultiSelectRefinementList from "components/search/base/MultiSelectRefinementList";
import genreCategories from "components/search/references/genreCategories";

const GenreMultiSelect = () => {
  return (
    <MultiSelectRefinementList
      attribute="genre"
      categories={genreCategories}
      className="refinement-list__genre"
      id="refinement-list__genre"
      limit={100}
      name="refinement-list__genre"
      title="Genre"
    />
  );
};

export default GenreMultiSelect;
